import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { PhoneNumber } from 'app/core/models/essette-api';


@autoinject()
export class AlternateContactInfoComponent extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected isThisAlternateInfo: (number: PhoneNumber) => boolean =
        (number: PhoneNumber) => {
            return number.type?.systemCode === null;
        };


    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
        this.logger.source = this;
    }

    protected async activate(): Promise<void> { }

    //protected created(owningView: View, myView: View): void { }
    //protected bind(bindingContext: Object, overrideContext: Object): void { }
    //protected attached(): void { }
    //protected deactivate(): void { }
    //protected detached(): void { }
    //protected unbind(): void { }



    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////

}
